/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

if (typeof window !== 'undefined') {
  // This entry is loaded before the vendor and main bundles. Excalidraw reads
  // the value while its modules initialize, so setting it in main.tsx is too
  // late and causes its public CDN URL to be retained.
  window.EXCALIDRAW_ASSET_PATH = '/assets/excalidraw/';

  const resizeObserverMessage =
    /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;

  const suppressResizeObserverError = (
    event: ErrorEvent | PromiseRejectionEvent,
  ) => {
    const message =
      (event as ErrorEvent).message ??
      ((event as PromiseRejectionEvent).reason &&
        (event as PromiseRejectionEvent).reason.message) ??
      '';

    if (typeof message === 'string' && resizeObserverMessage.test(message)) {
      event.stopImmediatePropagation?.();
      event.preventDefault?.();
    }
  };

  window.addEventListener('error', suppressResizeObserverError, true);
  window.addEventListener(
    'unhandledrejection',
    suppressResizeObserverError,
    true,
  );

  const originalOnError = window.onerror;
  window.onerror = (...args) => {
    const [message] = args;
    if (typeof message === 'string' && resizeObserverMessage.test(message)) {
      return true;
    }
    if (typeof originalOnError === 'function') {
      return originalOnError.apply(window, args);
    }
    return false;
  };

  const originalOnUnhandledRejection = window.onunhandledrejection;
  window.onunhandledrejection = (event) => {
    const message = event?.reason?.message ?? event?.reason ?? '';
    if (typeof message === 'string' && resizeObserverMessage.test(message)) {
      return true;
    }
    if (typeof originalOnUnhandledRejection === 'function') {
      return originalOnUnhandledRejection.call(window, event);
    }
    return false;
  };
}
